import { useRef, useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import { getTeamsClientEffect, resetClientsSearchEffect, searchClientsEffect } from 'store/effects';
import { Modal, Wrapper as PendingWrapper, SearchFieldWithDebounce } from 'components';
import {
  getClientsSelector,
  getTeamDetailsDashboardSelector,
} from 'store/selectors/adminPanel/teamDetails';
import GroupBy from '../Members/Components/GroupBy';
import { TeamsTable } from '../Members/Components/TeamsTable';
import { tableColumns } from './tableColumns';
import { LoginLogsModal } from '../Members/LoginHistoryModal';

import styles from './styles.module.scss';
import ViewUser from 'pages/Dashboard/Users/View';

const Clients = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const hasBeenRendered = useRef(false);
  const [clientsGroupBy, setClientsGroupBy] = useState('active');
  const teamClients = useSelector(getClientsSelector);
  const [currentData, setCurrentData] = useState<any>();
  const [openLoginLogsModal, setOpenLoginLogsModal] = useState(false);
  const { isPending, isIdle } = useSelector(getTeamDetailsDashboardSelector);
  const teamId = params?.id;
  const [previewUserId, setPreviewUserId] = useState(null);

  const getTeamClients = (idle) => {
    if (idle) {
      dispatch(getTeamsClientEffect({ teamId, isActive: clientsGroupBy === 'active' }, {}));
    } else {
      dispatch(
        getTeamsClientEffect({ teamId, isActive: clientsGroupBy === 'active' }, { silent: true }),
      );
    }
  };

  useEffect(() => {
    if (hasBeenRendered.current) {
      getTeamClients(true);
    } else {
      getTeamClients(isIdle);
    }
    hasBeenRendered.current = true;
  }, [clientsGroupBy]);

  const onLoginClick = (data) => {
    setCurrentData(data);
    setOpenLoginLogsModal(true);
  };

  const tableProps = {
    columns: tableColumns(onLoginClick),
    onRow: ({ Id }) => {
      return {
        onClick: (event) => {
          setPreviewUserId(Id);
        },
      };
    },
  };

  const onPreviewModalClose = useCallback(() => setPreviewUserId(null), [setPreviewUserId]);

  return (
    <div>
      <PendingWrapper
        isPending={isPending}
        className={classNames({ [styles.pendingWrapper]: isPending })}
      >
        <div className={styles.titleBar}>
          <div>
            <span className={styles.clientsTitle}>
              Clients <span className={styles.membersCount}>{`(${teamClients.length})`}</span>
            </span>
          </div>
          <div className={styles.actions}>
            <div className={styles.searchWrapper}>
              <SearchFieldWithDebounce
                className={styles.inputWrap}
                classNameInput={styles.searchInput}
                iconClassName={styles.icon}
                resetAction={resetClientsSearchEffect}
                sendAction={searchClientsEffect}
                isLoading={isPending}
                placeholder="Search"
                testid="search"
                isTransactionAggregate={true}
                isExpandedVersion
              />
            </div>
            <GroupBy membersGroupBy={clientsGroupBy} setMembersGroupBy={setClientsGroupBy} />
          </div>
        </div>
        <TeamsTable dataSource={teamClients} {...tableProps} rowClassName={styles.rowClickable} />
      </PendingWrapper>
      {openLoginLogsModal && (
        <LoginLogsModal
          isOpen={openLoginLogsModal}
          onCloseModal={() => setOpenLoginLogsModal(false)}
          agentEmail={`${currentData?.Email}`}
        />
      )}
      <Modal
        isOpen={!!previewUserId}
        onClose={onPreviewModalClose}
        innerHolderClassName={styles.modalInnerHolder}
        contentClassName={styles.modalContent}
      >
        {!!previewUserId && <ViewUser id={previewUserId} onClose={onPreviewModalClose} />}
      </Modal>
    </div>
  );
};

export default Clients;
